import React, { useState } from 'react';

const DailyCard = ({ day, dayInCurrentMonth, onClick = () => {}, isToday, data, haveData, overToday }) => {
  const [over, setOver] = useState(false);
  const isHoliday = day._d.getDay() === 0 || day._d.getDay() === 6;
  const titleColor = `${isHoliday ? '#ff0000' : (isToday ? 'white' : '#000000')}${dayInCurrentMonth ? '' : '50'}`;
  const disable = overToday;

  // const handleMouseOver = () => !disable && haveData && setOver(true);
  // const handleMouseOut = () => !disable && haveData && setOver(false);
  // const handleClick = () => !disable && haveData && onClick();

  const handleMouseOver = () => !disable && setOver(true);
  const handleMouseOut = () => !disable && setOver(false);
  const handleClick = () => !disable && onClick();

  const cardStyles = {
    marginTop: 8,
    marginLeft: 8,
    marginRight: 8,
    backgroundColor: over ? '#C1C1C1' : 'transparent',
    cursor: disable ? 'default' : 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 10,
  };

  const dateBoxStyles = {
    fontWeight: 700,
    fontSize: 20,
    color: titleColor,
    height: 28,
    width: 28,
    borderRadius: 15,
    backgroundColor: isToday ? '#4CC2CA' : 'transparent',
  };

  const detailsBoxStyles = {
    width: 90,
    height: 168,
    marginTop: 8,
    fontSize: 10,
    fontWeight: 700,
    backgroundColor: over ? '#C1C1C1' : (isHoliday ? '#F0F0F0' : 'transparent'),
    borderRadius: 10,
    textAlign: 'start',
  };

  return (
    <>
      <div style={cardStyles} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onClick={handleClick}>
        <div style={dateBoxStyles}>{day.format('D')}</div>
        {!overToday && (
          <div style={detailsBoxStyles}>
            <div style={{ color: over ? 'white' : (haveData ? '#f5ad76' : '#B8B8B8'), fontSize: 15, fontWeight: 500 }}>點選日期</div>
            <div style={{ color: over ? 'white' : (haveData ? '#f5ad76' : '#B8B8B8'), fontSize: 15, fontWeight: 500 }}>查詢進度</div>
          </div>
        )}
        {overToday && <div style={detailsBoxStyles} />}
      </div>
    </>
  );
};

export default DailyCard;

